import { Grid } from '@mui/material';
import { memo } from 'react';
import { AccordionCancelMarriage } from 'mutation/view-models/cancel-marriage';
import TypeVoidMarriageList from 'shell/components/shared/type-void-marriage-list';
import { FormikErrors, FormikTouched } from 'formik';
import Judgment from './judgment';
import CancelAct from './cancel-act';

interface FormProps {
  values?: AccordionCancelMarriage;
  onChange: (
    key: keyof AccordionCancelMarriage,
    value: AccordionCancelMarriage[keyof AccordionCancelMarriage]
  ) => void;
  errors?: FormikErrors<AccordionCancelMarriage>;
  touched?: FormikTouched<AccordionCancelMarriage>;
  onChangeValues: (values: AccordionCancelMarriage) => void;
}

const FormComponent = ({
  values,
  onChange,
  touched,
  errors,
  onChangeValues,
}: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <TypeVoidMarriageList
          required
          label="Tipo cessazione"
          aria-label="Tipo cessazione"
          value={values?.type || ''}
          onChange={(value) => onChange('type', value)}
          error={touched?.type && Boolean(errors?.type)}
        />
      </Grid>
      <Grid item xs={12}>
        <Judgment values={values} onChange={onChange} touched={touched} errors={errors} />
      </Grid>
      <Grid item xs={12}>
        <CancelAct
          values={values}
          onChange={onChange}
          touched={touched}
          errors={errors}
          onChangeValues={onChangeValues}
        />
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Form Cancel marriage accordion component';

const Form = memo(FormComponent);

export default Form;
